// TenantCheckoutModal.js
import React, { useState } from 'react';
import { tenantCheckout } from '../apis/services/pgApi';
import '../scss/components/_tenantcheckout.scss'; // Import the new SCSS file

const TenantCheckoutModal = ({ bed, pgId, onClose, onSuccess }) => {

    console.log("bed in modal", bed);
    
  const [checkoutDate, setCheckoutDate] = useState(() => {
    // Default to today's date
    const today = new Date();
    return today.toISOString().split('T')[0];
  });
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState('');

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  }

  const handleSubmit = async () => {
    if (!checkoutDate) {
      setError('Please select a checkout date');
      return;
    }

    if (!bed?.AdmissionID) {
      setError('No admission ID found for this tenant');
      return;
    }

    setIsProcessing(true);
    setError('');

    try {
      const payload = {
        AdmissionId: bed.AdmissionID,
        PGID: pgId,
        CheckoutDate: checkoutDate
      };

      const response = await tenantCheckout(payload);
      
      if (response.Success === 1) {
        // Success
        onSuccess(bed.BedID);
        onClose();
      } else {
        setError(response.Message || 'Checkout failed');
      }
    } catch (err) {
      setError(err.message || 'An error occurred during checkout');
    } finally {
      setIsProcessing(false);
    }
  };

  // Get tenant details from bed object
  const tenantName = bed.TenantName || 'Unknown Tenant';
  const roomNumber = bed.roomNumber || 'N/A';
  const bedNumber = bed.bedNumber || 'N/A';
  const checkInDate = bed.checkInDate;
  const admissionId = bed.AdmissionID;

  return (
    <div className="tcc-modal-overlay" >
      <div className="tcc-checkout-modal" onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div className="tcc-modal-head">
          <h3>Tenant Checkout</h3>
          <button className="tcc-modal-close" onClick={onClose}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        {/* Tenant Details */}
        <div className="tcc-tenant-details">
          <div className="tcc-detail-row">
            <span className="tcc-detail-label">Tenant Name:</span>
            <span className="tcc-detail-value">{tenantName}</span>
          </div>
          <div className="tcc-detail-row">
            <span className="tcc-detail-label">Room No:</span>
            <span className="tcc-detail-value">{roomNumber}</span>
          </div>
          <div className="tcc-detail-row">
            <span className="tcc-detail-label">Bed No:</span>
            <span className="tcc-detail-value">{bedNumber}</span>
          </div>
          <div className="tcc-detail-row">
            <span className="tcc-detail-label">Check-in Date:</span>
            <span className="tcc-detail-value">{formatDate(checkInDate)}</span>
          </div>
          <div className="tcc-detail-row">
            <span className="tcc-detail-label">Admission ID:</span>
            <span className="tcc-detail-value">{admissionId}</span>
          </div>
        </div>

        {/* Checkout Date Selection */}
        <div className="tcc-checkout-date">
          <label className="tcc-checkout-label">
            Checkout Date <span className="tcc-required">*</span>
          </label>
          <input
            type="date"
            className="tcc-checkout-input"
            value={checkoutDate}
            onChange={(e) => setCheckoutDate(e.target.value)}
            max={new Date().toISOString().split('T')[0]} // Cannot select future dates
            required
          />
        </div>

        {/* Note */}
        <div className="tcc-checkout-note">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          <span>Note: Tenant must clear all dues before checkout</span>
        </div>

        {error && (
          <div className="tcc-checkout-error">
            {error}
          </div>
        )}

        <div className="tcc-modal-actions">
          <button className="tcc-modal-cancel" onClick={onClose}>
            Cancel
          </button>
          <button 
            className="tcc-modal-confirm" 
            onClick={handleSubmit}
            disabled={isProcessing}
          >
            {isProcessing ? (
              <>
                <span className="tcc-loading"></span>
                Processing...
              </>
            ) : (
              'Confirm Checkout'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TenantCheckoutModal;